const BlockchainCertification = () =>{
    return(
        <div>
            <iframe src="https://app.bernstein.io/abion"/>
        </div>
    )
}
export default BlockchainCertification